module.exports = __webpack_public_path__ + "img/9f1.d5d93959.jpg";